import {FC, ReactNode} from "react";
import {EventsProvider} from "./EventsProvider";

type Props = {
  children: ReactNode;
}

export const AuthenticatedProviders: FC<Props> = ({children}) => {

  // pass down providers (across routes) for authenticated users
  return (
    <EventsProvider>
      {children}
    </EventsProvider>
  )
}
